import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('client-certificates', { routeName: 'frontdoorResourceRoute' })
export class ClientCertificate extends Resource {
    id: string;
    name: string;
    value: string;
    selected: boolean;
    /**
     * When the stored certificate stops working, or absent where the service could not parse one
     * out of the stored body. For a bundle it is the earliest expiry in it, because a bundle stops
     * working when its earliest member does.
     */
    expiresAt?: string;
}

